"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KpiWidgetDateDatasetFilter = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var sdk_model_1 = require("@gooddata/sdk-model");
var common_1 = require("../../common");
var model_1 = require("../../../../model");
var useDateDatasetFilter_1 = require("../../common/configuration/useDateDatasetFilter");
exports.KpiWidgetDateDatasetFilter = function (props) {
    var widget = props.widget;
    var ref = sdk_model_1.widgetRef(widget);
    var _a = model_1.useDashboardQueryProcessing({
        queryCreator: model_1.queryDateDatasetsForMeasure,
    }), status = _a.status, queryDateDatasets = _a.run, result = _a.result;
    react_1.useEffect(function () {
        queryDateDatasets(widget.kpi.metric);
    }, [queryDateDatasets, widget.kpi.metric]);
    var isWidgetDateDatasetAutoSelect = model_1.useDashboardSelector(model_1.selectWidgetDateDatasetAutoSelect);
    var isLoadingAdditionalData = model_1.useDashboardSelector(model_1.selectIsWidgetLoadingAdditionalDataByWidgetRef(ref));
    var dispatch = model_1.useDashboardDispatch();
    var preselectDateDataset = model_1.useDashboardCommandProcessing({
        commandCreator: model_1.enableKpiWidgetDateFilter,
        successEvent: "GDC.DASH/EVT.KPI_WIDGET.FILTER_SETTINGS_CHANGED",
        errorEvent: "GDC.DASH/EVT.COMMAND.FAILED",
        onError: function () {
            dispatch(model_1.uiActions.setWidgetLoadingAdditionalDataStopped(ref));
            dispatch(model_1.uiActions.setWidgetDateDatasetAutoSelect(false));
        },
        onSuccess: function () {
            dispatch(model_1.uiActions.setWidgetLoadingAdditionalDataStopped(ref));
        },
    }).run;
    // preselect the first dataset upon loading if the auto select was true
    react_1.useEffect(function () {
        if (isWidgetDateDatasetAutoSelect) {
            preselectDateDataset(ref, "default");
        }
    }, [isWidgetDateDatasetAutoSelect, dispatch, ref, preselectDateDataset]);
    var _b = useDateDatasetFilter_1.useDateDatasetFilter(result === null || result === void 0 ? void 0 : result.dateDatasets), handleDateDatasetChanged = _b.handleDateDatasetChanged, shouldOpenDateDatasetPicker = _b.shouldOpenDateDatasetPicker;
    return (react_1.default.createElement("div", { className: "gd-kpi-date-dataset-dropdown" },
        react_1.default.createElement(common_1.DateDatasetFilter, { widget: widget, dateFilterCheckboxDisabled: false, isDatasetsLoading: status === "running" || status === "pending" || isLoadingAdditionalData, relatedDateDatasets: result === null || result === void 0 ? void 0 : result.dateDatasetsOrdered, shouldPickDateDataset: isWidgetDateDatasetAutoSelect, shouldOpenDateDatasetPicker: shouldOpenDateDatasetPicker, isLoadingAdditionalData: isLoadingAdditionalData, onDateDatasetChanged: handleDateDatasetChanged })));
};
//# sourceMappingURL=KpiWidgetDateDatasetFilter.js.map